<template>
  <b-modal
    v-model="showModal"
    header-class="header-class-modal-doc-package"
    :title="FormMSG(1, 'Request Information')"
    size="lg"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <b-form-group>
      <template #label>
        <label>{{ FormMSG(2, 'Select Person') }}</label>
        <span class="text-danger"><strong> *</strong></span>
      </template>
      <v-select
        v-model="requestReceiverId"
        class="w-100"
        :placeholder="FormMSG(3, 'Select user to receive the request here...')"
        :options="usersList"
        label="name"
        :reduce="(option) => option.value"
      ></v-select>
    </b-form-group>
    <b-form-group>
      <template #label>
        <label>{{ FormMSG(4, 'Enter your comment:') }}</label>
        <span class="text-danger"><strong> *</strong></span>
      </template>
      <b-form-textarea id="comment" v-model="requestMessage" rows="6" />
    </b-form-group>
    <template #modal-footer>
      <div class="w-100 d-flex flex-row justify-content-end align-items-center">
        <b-button size="sm" variant="custom-outline-gray" class="w-138-px" block @click="closeModal">
          {{ FormMSG(5, 'Close') }}
        </b-button>
        <b-button
          v-b-tooltip.hover
          :title="disableSentTooltipMsg"
          :disabled="isDisableSend"
          size="sm"
          variant="custom-primary-blue"
          class="w-138-px ml-2"
          style="margin-top: -1px"
          block
          @click="sendRequest"
        >
          <div class="d-flex justify-content-center align-items-center" style="gap: 7px">
            <b-spinner v-if="isSending" small></b-spinner>
            <component :is="getLucideIcon('Send')" v-else :size="16" :stroke-width="3" />
            <div class="pl-2" style="margin-top: 1px">{{ FormMSG(6, 'Send') }}</div>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { sendInvoiceRequestInfo } from '@/cruds/expense.crud';
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';

export default {
  name: 'DialogRequestInfoInvoice',
  mixins: [languageMessages, globalMixin],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    invoiceId: {
      type: Number,
      required: false,
      default: null
    },
    usersList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      requestReceiverId: null,
      requestMessage: '',
      disableSentTooltipMsg: '',
      isSending: false
    };
  },
  computed: {
    isDisableSend() {
      return !!(!this.requestReceiverId || this.requestMessage.length < 3 || this.isSending);
    }
  },
  watch: {
    show(newValue) {
      this.showModal = newValue;
      if (newValue) {
        this.requestMessage = this.FormMSG(
          7,
          'We received an electronic invoice which may be related to you. You\'re invited to create a new "Peppol invoice" in TheGreenShot app. to be refunded.'
        );
      }
    }
  },
  created() {
    this.disableSentTooltipMsg = this.FormMSG(12, 'Please, make shure that you have already select a receiver and give enough description in the comment');
  },
  methods: {
    async sendRequest() {
      this.isSending = true;
      try {
        const variables = {
          userId: +this.requestReceiverId,
          message: this.requestMessage,
          expenseId: +this.invoiceId
        };
        const sentResult = await sendInvoiceRequestInfo(variables);
        if (sentResult) {
          this.createToastForMobile(this.FormMSG(8, 'Success'), this.FormMSG(10, 'Your request was sent successfully'));
          this.closeModal();
        } else {
          this.createToastForMobile(this.FormMSG(9, 'Error'), this.FormMSG(11, 'the system encoutered error when sending the request'), '', 'danger');
        }
      } catch (error) {
        this.createToastForMobile(this.FormMSG(9, 'Error'), this.FormMSG(11, 'the system encoutered error when sending the request'), '', 'danger');
      }
      this.isSending = false;
    },
    closeModal() {
      this.isSending = false;
      this.requestReceiverId = null;
      this.requestMessage = '';
      this.$emit('close');
    }
  }
};
</script>
